package com.artvending.warden.screens.history

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
//import androidx.compose.ui.unit.Dp
import com.artvending.warden.HistoryUnit
import com.artvending.warden.Page
import com.artvending.warden.ScreenModel
import com.artvending.warden.getMonthFullNumber
import com.artvending.warden.getMonthStr
import com.artvending.warden.loadMonth
import com.artvending.warden.commonSettings
import com.artvending.warden.today
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.datetime.LocalDate

class HistoryScreenModel(selectedDate: LocalDate? = null) : ScreenModel() {
	var isCalendarMode by mutableStateOf(true)
	var units by mutableStateOf(emptyList<HistoryUnit>())
	var currentMonth by mutableStateOf(today.getMonthFullNumber())
	var selectedDate by mutableStateOf(selectedDate)
	var progress by mutableStateOf(false)
	
	val currentMonthStr: String
		get() = getMonthStr((currentMonth % 12) + 1)
	
	val selectedDateUnits
		get() = units.filter { it.date == selectedDate }
	
	
	@Composable
	override fun Display(scope: Any?) {
		scope.HistoryScreen(this)
	}
	
	
	override fun enter() {
		loadCurrentMonth(currentMonth)
	}
	
	
	@OptIn(DelicateCoroutinesApi::class)
	fun loadCurrentMonth(month: Int) {
		progress = true
		
		GlobalScope.launch {
			if (commonSettings.DEBUG_MODE)
				delay(1500)
			
			var units = loadMonth(month / 12, (month % 12) + 1)
			
			if (month == currentMonth) {
				this@HistoryScreenModel.units = units
				progress = false
			}
		}
	}
	
	
	fun selectDate(date: LocalDate) {
		selectedDate = date
	}
	
	
	companion object{
		//var cellSize: Dp? by mutableStateOf(null)
	}
	
	override val page: Page?
		get() = Page.HISTORY
}


@Composable
expect fun Any?.HistoryScreen(model: HistoryScreenModel)